import * as React from 'react';
import { gql, useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import { PlanUsageType, UsageFieldsFragmentDoc, useDeleteImportSourceMutation } from '../../../../models/graphql';
import { DeleteSourceModalView } from './DeleteSourceModal.view';

gql`
  mutation DeleteImportSource($importSourceId: ID!) {
    deleteImportSource(importSourceId: $importSourceId)
  }
`;

export type DeleteSourceModalApolloProps = {
  // ...
};

export const DeleteSourceModalApollo = (props: DeleteSourceModalApolloProps): JSX.Element => {
  const [deleteImportSource] = useDeleteImportSourceMutation();
  const { cache } = useApolloClient();
  const deleteSourceHandler = useCallback(
    async (id: string) => {
      try {
        await deleteImportSource({
          variables: { importSourceId: id },
          update: cache => {
            cache.evict({ id: cache.identify({ id: id, __typename: 'ImportSource' }) });
            cache.gc();
          }
        });
        // TODO this should go inside update callback not like this
        const oldUsage: PlanUsageType | null = cache.readFragment({
          fragment: UsageFieldsFragmentDoc,
          fragmentName: 'UsageFields',
          id: 'PlanUsageType:{}'
        });
        const newUsage = { ...oldUsage, importSources: (oldUsage?.importSources ?? 0) - 1 };
        cache.writeFragment({
          fragment: UsageFieldsFragmentDoc,
          fragmentName: 'UsageFields',
          id: 'PlanUsageType:{}',
          data: newUsage
        });
      } catch (error) {}
    },
    [deleteImportSource, cache]
  );

  const viewProps = {
    ...props,
    deleteSourceHandler
  };

  return <DeleteSourceModalView {...viewProps} />;
};
